import React from 'react'
import  { useEffect} from 'react'
import { NavLink } from 'react-router-dom';
import {Container, Divider, Grid} from 'semantic-ui-react';
import useObtenerProductos from '../../../hooks/obtenerProductos';
import useObtenerDetallesdecuenta from '../../../hooks/obtenerDetallesdecuenta';

const Productodisp = (props) => {
    // console.log('Productos disponibles')
//    // console.log(props.companyID)
//    // console.log(props.companyID.companyUid)
var companyUid = props.companyID? props.companyID.companyUid : null

    const  {accountDetails, accountDetailsHistory, availableservices, loadingDetallesdecuenta, errorDetallesdecuenta} = useObtenerDetallesdecuenta(companyUid)
    const {productosBolsas, productosplanes, loadingProductos, errorProductos} = useObtenerProductos()
    const [itemDetailsPlans,setItemDetailsPlans] = React.useState('')
    const [itemDetailsPacks,setItemDetailsPacks] = React.useState('')
  
//filters

useEffect(()=>{
    if(accountDetails){
       // console.log(accountDetails)
      // // console.log(accountDetails.currentPack)
      // // console.log(accountDetails.currentPlan)
      // // console.log(accountDetails.currentPlanCustom)
    }
  },[accountDetails])
  
  const plansActive = props.plansdata.filter(item => item.isActive === true) // Activo
  
  const plansPost = plansActive.filter(item => item.isPost === true) // Is post
  
  plansPost.sort((a, b) => (parseInt(a.position) > parseInt(b.position))?1:-1) ;
  
// console.log(productosBolsas)
// console.log(productosplanes)


  useEffect(()=>{
    if(productosBolsas){
      console.log(accountDetails)
      if(accountDetails !== 'error'){
      var detailsPlans = productosplanes.filter(item => item.id === accountDetails.currentPlan )

      setItemDetailsPlans(detailsPlans[0])
      
      var detailsPacks = productosBolsas.filter(item => item.id === accountDetails.currentPack )

      setItemDetailsPacks(detailsPacks[0])
      }
    }
  },[productosBolsas])

  useEffect(()=>{

  },[itemDetailsPacks, itemDetailsPlans ])


  return (
    <Container className='dashcontent'>
  <Grid celled='internally'  id='mi-cuentaContent'>
  <div><h2> Detalles de productos</h2></div>
  
        <Grid.Row  className="divmap" >
   
           <Grid.Column computer={6} mobile={16} tablet={16} className="dash-container-colmun">
          <Grid.Row className="distproductos">
            <div>
            <h3>BOLSAS DE ENVÍOS</h3>
            </div>
          </Grid.Row>
          <Grid.Row className="distproductos">
            {
              accountDetails?(<>
                {
                  accountDetails.currentPack!==""?( 
                    <NavLink to="/dashboard/servicios/seleccione_pack"  className='btncambiar'>
                    <div  >Comprar</div>
                    </NavLink> 
                    ):( 
                    <NavLink to="/dashboard/servicios/seleccione_pack"   className='btncambiar'>
                    <div  >Contratar</div>
                    </NavLink>
                    )
                }
              </>):(<div>'Cargando'</div>)
            }
          
          
            </Grid.Row>
            </Grid.Column>
            <Grid.Column computer={10} mobile={16} tablet={16} className="dash-container-colmun ">
              <Grid.Row className=" distproductosdescrip">
          {
            accountDetails?(<>   
            <Grid.Column className="dash-container-colmun-equal">
            {
              accountDetails.currentPack!==""?(<h5>{itemDetailsPacks.productName}</h5>):(<></>)
            }
              
              
            </Grid.Column>
            <Grid.Column className="dash-container-colmun-equal">
            {
              accountDetails.currentPack!==""?(<>{itemDetailsPacks.description} </>):(<>Contrate un servicio</>)
            }
              {/* <h5>descripcion del producto</h5> cuenta con : SI POSEE <ul></ul> */}
            </Grid.Column>
            <Grid.Column className="dash-container-colmun-equal"> 
            {
              itemDetailsPacks?(<>costo: ${itemDetailsPacks.total}</>):(<></>)
            }
            </Grid.Column>

            </>):(<>
            <Grid.Column className="dash-container-colmun-equal">NO POSEE PLAN PERSONALIZADO </Grid.Column>
            <Grid.Column className="dash-container-colmun-equal"><h5>Solicite uno personalizado para su empresa </h5> Número de envíos a medida <ul></ul></Grid.Column>
            <Grid.Column className="dash-container-colmun-equal">costo: desde $250.000</Grid.Column>
            </>)
          }
              </Grid.Row>
              <Grid.Row className="distproductosdescrip">
                  {
                  accountDetails?(<>
                    <Grid.Column  className="dash-container-colmun-equal">Uso: </Grid.Column>
                    <Grid.Column className="dash-container-colmun-equal">cuenta con {itemDetailsPacks?(itemDetailsPacks.ChargeShipments):(0)} envíos </Grid.Column>
                    </>):(<>
                    <Grid.Column  className="dash-container-colmun-equal">Uso</Grid.Column>
                    <Grid.Column className="dash-container-colmun-equal">catidad de DISPONIBLE</Grid.Column>
                    </>)
                  }
              <Grid.Column ></Grid.Column>
              </Grid.Row>
            </Grid.Column>
        </Grid.Row> 

        <Grid.Row  className="divmap" >
            <Grid.Column computer={6} mobile={16} tablet={16} className="dash-container-colmun">
            <Grid.Row className="distproductos">
              <div>
              <h3>PLANES CORPORATIVOS</h3>
              </div>
            </Grid.Row>
            <Grid.Row className="distproductos">
            {
                      accountDetails?(<>
                        {
                          accountDetails.currentPlan!==""?( 
                            <NavLink to="/dashboard/servicios/seleccione_plan" className='btncambiar'>
                            <div  >Cambiar</div>
                            </NavLink> 
                            ):( 
                            <NavLink to="/dashboard/servicios/seleccione_plan" className='btncambiar'>
                            <div  >Contratar</div>
                            </NavLink>
                            )
                        }
                      </>):(<div>'Cargando'</div>)
                    }
                  
              </Grid.Row>
            </Grid.Column>

            <Grid.Column computer={10} mobile={16} tablet={16} className="dash-container-colmun ">
              <Grid.Row className=" distproductosdescrip">

                {
                  accountDetails?(<> 
                    {
                      itemDetailsPlans?(<>
                       
                    <Grid.Column className="dash-container-colmun-equal">
                    {
                      itemDetailsPlans.type!=='custom'?(<h5>{accountDetails.currentPlan}<br></br>Servicio con cargo mensual</h5>):(<></>)
                    }
                    </Grid.Column>
                    <Grid.Column className="dash-container-colmun-equal">
                   
                    {
                      itemDetailsPlans.description
                    }
                   <br></br>
                   
                    Cuenta con: 
                    {
                     <>{itemDetailsPlans.ChargeShipments} envíos agregados a su cuenta periodicamente</>
                    } <ul></ul>
                    
                    </Grid.Column>
                    <Grid.Column className="dash-container-colmun-equal">costo: $ {itemDetailsPlans.salePrice}</Grid.Column>
                    </>):(<>
                      <Grid.Column className="dash-container-colmun-equal">No posee un plan estándar </Grid.Column>
                      <Grid.Column className="dash-container-colmun-equal"><h5>Solicite uno si se ajusta a su empresa empresa </h5> Número de envíos a medida <ul></ul></Grid.Column>
                      <Grid.Column className="dash-container-colmun-equal">costo: desde $60.000 </Grid.Column>
                    </>)
                    } 
                  </>):(<>
            
                  </>)
                }

              </Grid.Row>
              <Grid.Row className="distproductosdescrip">
                {
                accountDetails?(<>
                      {
                      itemDetailsPlans?(<>
                      <Grid.Column  className="dash-container-colmun-equal">Uso:</Grid.Column>
                      <Grid.Column className="dash-container-colmun-equal">cuenta con {itemDetailsPlans.ChargeShipments} envíos</Grid.Column>
                      </>):(<>
                        <Grid.Column  className="dash-container-colmun-equal">Uso:</Grid.Column>
                        <Grid.Column className="dash-container-colmun-equal">Los envíos que se adapten a sus nececidades</Grid.Column>
                      </>)
                      }
                  </>):(<>
                  </>)
                }



              <Grid.Column ></Grid.Column>
              </Grid.Row>
            </Grid.Column>
        </Grid.Row> 

        <Grid.Row  className="divmap" >
            <Grid.Column computer={6} mobile={16} tablet={16} className="dash-container-colmun">
            <Grid.Row className="distproductos">
              <div>
              <h3>PLANES PERSONALIZADO</h3>
              </div>
            </Grid.Row>
            <Grid.Row className="distproductos">
            {
                      accountDetails?(<>
                        {/* {
                          accountDetails.currentPlan!==""?( 
                            <NavLink to="/dashboard/servicios/seleccione_plan" className='btncambiar'>
                            <div  >Cambiar</div>
                            </NavLink> 
                            ):( 
                            <NavLink to="/dashboard/servicios/seleccione_plan" className='btncambiar'>
                            <div  >Contratar</div>
                            </NavLink>
                            )
                        } */}
                      </>):(<div>'Cargando'</div>)
                    }
                  
              </Grid.Row>
            </Grid.Column>

            <Grid.Column computer={10} mobile={16} tablet={16} className="dash-container-colmun ">
              <Grid.Row className=" distproductosdescrip">

                {
                  accountDetails?(<> 
                    {
                      itemDetailsPlans?(<>
                       
                    <Grid.Column className="dash-container-colmun-equal">
                    {
                      itemDetailsPlans.type==='custom'?(<h5>{accountDetails.currentPlan}<br></br>Servicio con cargo mensual</h5>):(<></>)
                    }
                    </Grid.Column>
                    <Grid.Column className="dash-container-colmun-equal">
                   
                    {
                      itemDetailsPlans.description
                    }
                   <br></br>
                   
                    Cuenta con : 
                    {
                     <>{itemDetailsPlans.ChargeShipments} envíos agregados a su cuenta periodicamente</>
                    } <ul></ul>
                    
                    </Grid.Column>
                    <Grid.Column className="dash-container-colmun-equal">costo: $ {itemDetailsPlans.salePrice}</Grid.Column>
                    </>):(<>
                      <Grid.Column className="dash-container-colmun-equal">No posee un plan estándar </Grid.Column>
                      <Grid.Column className="dash-container-colmun-equal"><h5>Solicite uno si se ajusta a su empresa empresa </h5> Número de envÍos a medida <ul></ul></Grid.Column>
                      <Grid.Column className="dash-container-colmun-equal">costo: desde $60.000 </Grid.Column>
                    </>)
                    } 
                  </>):(<>
            
                  </>)
                }

              </Grid.Row>
              <Grid.Row className="distproductosdescrip">
                {
                accountDetails?(<>
                      {
                      itemDetailsPlans?(<>
                      <Grid.Column  className="dash-container-colmun-equal">Uso:</Grid.Column>
                      <Grid.Column className="dash-container-colmun-equal">cuenta con {itemDetailsPlans.ChargeShipments} envíos</Grid.Column>
                      </>):(<>
                        <Grid.Column  className="dash-container-colmun-equal">Uso:</Grid.Column>
                        <Grid.Column className="dash-container-colmun-equal">Los envíos que se adapten a sus necesudades</Grid.Column>
                      </>)
                      }
                  </>):(<>
                  </>)
                }



              <Grid.Column ></Grid.Column>
              </Grid.Row>
            </Grid.Column>
        </Grid.Row> 
 
        <Grid.Row  className="divmap" >
          
          <Grid.Column computer={6} mobile={16} tablet={16} className="dash-container-colmun">
          <Grid.Row className="distproductos">
            <div>
            <h3>SOLICITAR ACCESORIA</h3>
            </div>
          </Grid.Row>
          <Grid.Row className="distproductos">
          {
                    accountDetails?(<>
                          {
                          <NavLink to="/soporte" className='btncambiar'>
                          <div  >Contacto</div>
                          </NavLink> 
                          }
                    </>):(<div>'Cargando'</div>)
                  }
                
            </Grid.Row>
          </Grid.Column>
          <Grid.Column computer={10} mobile={16} tablet={16} className="dash-container-colmun ">
          <Grid.Row className=" distproductosdescrip">

          <Grid.Column className="dash-container-colmun-equal">
          <NavLink to="/soporte" className='btncambiar'>
          <div>WhatsApp</div>
          </NavLink> 
          </Grid.Column>
          <Grid.Column className="dash-container-colmun-equal">
          <NavLink to="/soporte" className='btncambiar'>
          <div>Contacto</div>
          </NavLink> 
          </Grid.Column>
          <Grid.Column className="dash-container-colmun-equal">
          <NavLink to="/soporte" className='btncambiar'>
          <div>Formulario</div>
          </NavLink> 
          </Grid.Column>
            
          </Grid.Row>
          <Grid.Row className="distproductosdescrip">
          <Grid.Column  className="dash-container-colmun-equal"></Grid.Column>
          <Grid.Column className="dash-container-colmun-equal">
            {/* Mensajes enviados */}
            </Grid.Column>
          <Grid.Column ></Grid.Column>
          </Grid.Row>
          </Grid.Column>
          
        </Grid.Row> 

 <Divider></Divider>
 <Grid.Row > 
 
 {
  itemDetailsPlans?(<>  Estimado para próxima factura  es de ${itemDetailsPlans.ChargeAmount} La estimación se calcula en función del uso actual y puede cambiar debido a excedentes.
    Si tiene cambios de cuenta recientes o pendientes o cargos únicos, no se reflejarán en esta estimación.</>):(<></>)
 }
    
          
          <br></br>
          <NavLink to="/#" className='btncambiar'> <div  >Congelar cuenta</div></NavLink> 
 </Grid.Row> 
 </Grid>
 </Container>
 )
}

export default Productodisp